<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { computed, inject, ref, type Ref } from 'vue';

  import { useI18 } from '@/plugins';
  import { useAuthStore } from '@/stores/auth.store';

  import SearchField from '../HeaderSearchField.vue';

  import LanguageToggle from './../../LanguageToggle.vue';
  import LoginAndRegister from './../../LoginAndRegister.vue';
  import SideMenuItems from './SideMenuItems.vue';

  const isLTR: Ref<boolean> = inject('isLTR', ref(true));
  defineProps<{ openMenu: boolean }>();
  const emits = defineEmits<{
    (event: 'update:openMenu', value: boolean): void;
  }>();
  const authStore = useAuthStore();
  const { user } = storeToRefs(authStore);
  const isLoggedIn = computed(() => !!user.value?.id);
  const { t } = useI18();
</script>

<template>
  <v-navigation-drawer
    :id="isLTR ? 'menu-drawer' : 'menu-drawer-rtl'"
    temporary
    class="position-fixed nav-drawer"
    aria-label="Menu"
    :model-value="openMenu"
    aria-owns="menu-drawer-items"
    role="listbox"
    width="455"
    @update:model-value="emits('update:openMenu', $event)"
  >
    <div v-if="openMenu" class="position-absolute d-none d-sm-block close-icon">
      <v-btn size="40" icon @click="emits('update:openMenu', false)">
        <v-icon size="16" icon="mdi-close" />
      </v-btn>
    </div>
    <div class="d-sm-none position-absolute close-icon">
      <v-icon
        size="16"
        icon="mdi-close"
        role="option"
        aria-label="Close or open menu"
        @click="emits('update:openMenu', false)"
      />
    </div>
    <div role="option" class="mt-14">
      <div
        v-if="!isLoggedIn"
        class="d-flex w-100 flex-column-reverse align-start gap-2 px-2"
        role="option"
        aria-label="Login and register"
      >
        <LoginAndRegister />
      </div>
      <div v-else class="px-2">
        <SearchField :app-bar="openMenu" />
      </div>
      <v-divider class="my-2" />
      <div class="px-2">
        <SideMenuItems :rail="!openMenu" />
      </div>
      <v-divider class="my-2" />
      <v-list-item
        :title="t('menu.language')"
        base-color="gray"
        aria-label="language"
        role="menuitem"
      >
        <template #append>
          <div class="text-black">
            <LanguageToggle />
          </div>
        </template>
      </v-list-item>
    </div>
  </v-navigation-drawer>
</template>
<style lang="scss">
  .close-icon {
    top: 16px;
    right: -62px;

    @include screen(599px) {
      top: 30px;
      right: 20px;
    }
  }
</style>
